import React, { useMemo } from 'react';

import { useNavigate } from 'react-router-dom';

import { useEditGame, useUpdateCompetition } from '@pkg/hooks';

import { type Competition } from '@app/client/common/structs';

import { useHandleCreateCompetition } from '../CreateGame';
import { GameForm, useGetDuplicateDateDefaults } from '../GameForm';

export const EditGameData = ({ gameData, isDuplicate = false }: { gameData?: Competition; isDuplicate?: boolean }) => {
    const navigate = useNavigate();
    const createCompetition = useHandleCreateCompetition((slug) => {
        alert('Successfully created!');
        navigate(`/admin/fantasy/${slug}`);
    });

    const dateDefaults = useGetDuplicateDateDefaults(gameData);

    const { mutateAsync: updateGame, isPending } = useUpdateCompetition();
    const { toggleEdit } = useEditGame();

    function updateCompetition(patchGameData) {
        if (!isPending)
            updateGame(patchGameData).then((res) => {
                if (res.ok) {
                    if (isDuplicate) {
                        alert(`Successfully created ${res.value.name}!`);
                        navigate(`/admin/fantasy/${res.value.slug}`);
                    }
                    alert(`Successfully updated ${res.value.name}!`);
                    toggleEdit();
                } else {
                    alert(res.error);
                }
            });
    }

    const formattedData = useMemo(() => {
        if (gameData) {
            return isDuplicate
                ? {
                      ...gameData,
                      ...dateDefaults,
                      name: `${gameData?.name} (DUPLICATE)`,
                      id: '',
                  }
                : gameData;
        }
    }, [isDuplicate, gameData, dateDefaults]);

    return (
        <GameForm
            existingGame={formattedData}
            onUpdate={updateCompetition}
            onCreate={createCompetition}
            isDuplicate={isDuplicate}
        />
    );
};
